import React from "react";
import { useMediaQuery } from "react-responsive";
import RunClubAuth from "../pages/RunClubAuth.jsx";

const ResponsiveRunClubPage = () => {
  const isMobile = useMediaQuery({ maxWidth: 767 }); // Mobile breakpoint
  return isMobile ? <RunClubAuth /> : <RunClubAuth />;
};

export default ResponsiveRunClubPage;
